import { render, staticRenderFns } from "./LeaveNotInSchool.vue?vue&type=template&id=336acbc7&"
import script from "./LeaveNotInSchool.vue?vue&type=script&lang=js&"
export * from "./LeaveNotInSchool.vue?vue&type=script&lang=js&"
import style0 from "./LeaveNotInSchool.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports